<template>
  <div class="lang-switch">
    <button
      v-for="lang in langs"
      :key="lang"
      :class="{ active: current === lang }"
      @click="setLang(lang)"
      aria-label="Switch language"
    >
      {{ lang.toUpperCase() }}
    </button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const langs = ['en', 'es']
const current = locale
function setLang(lang) {
  locale.value = lang
}
</script>

<style scoped>
.lang-switch {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 999;
}
.lang-switch button {
  background: none;
  border: none;
  font-size: 1rem;
  margin-left: 0.5rem;
  color: #888;
  cursor: pointer;
  transition: color 0.2s;
}
.lang-switch button.active,
.lang-switch button:hover {
  color: #222;
  font-weight: bold;
}
</style>
